//const { redirectUri, postLogoutRedirectUri, cookiePrefix,clientId } = require('./config');
//const dotenv = require('dotenv');
//dotenv.config();
export default{
  oidc:{
    issuer:"https://hudsfdart.okta.com/oauth2/default",
    clientId:process.env.REACT_APP_CLIENT_ID,
    scopes:["openid","profile","email"],
    redirectUri:process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri:process.env.REACT_APP_POSTLOGOUT_REDIRECT_URI,
    cookiePrefix:process.env.REACT_APP_COOKIE_PREFIX,
  },
  widget:{
    issuer:"https://hudsfdart.okta.com/oauth2/default",
    clientId:process.env.REACT_APP_CLIENT_ID,
    redirectUri:process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri:process.env.REACT_APP_POSTLOGOUT_REDIRECT_URI,
    scopes:["openid","profile","email"],
    cookiePrefix:process.env.REACT_APP_COOKIE_PREFIX,

  },
};
